import { Flex, Button, Box, Center } from "@chakra-ui/react";
import { PlayingCard } from "../components";
import { useState } from "react";
import { dealCards } from "../utils/cardUtils";
import { Outlet } from "react-router-dom";
import { GameProvider } from "../context/gameContext/gameContext";

import styled from "styled-components";

const Play = () => {
  return (
    <GameProvider>
      <Flex flex="1" direction="column" gap={5}>
        <Outlet />
      </Flex>
    </GameProvider>
  );
};
export default Play;

const Wrapper = styled.div``;
